module.exports=function(scope){ return `// Method to create a valid string to pass as the value for the User-Agent header when calling the FaceTec Testing API.
// @param - sessionId - Unique Id for a User Session. This can be obtained from the ZoomSessionResult object, returned in the callback function onActivityResult once the User Session has completed
//
// @return - zoomAPIUserAgentString - String that can be used as the value for the User-Agent header when calling the FaceTec Testing API
//
String zoomAPIUserAgentString = ZoomSDK.createZoomAPIUserAgentString(sessionId);
`};


// WEBPACK FOOTER //
// ./src/resources/code/android/create-api-user-agent-string.java.tpl